import { call, put, takeLatest } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { accountBalanceServices } from './accountBalance.services';
import { accountBalanceSlice } from './accountBalance.slice';

const accountBalanceWorker = function* ({ payload }) {
  try {
    const { securityAccount, currency } = payload;

    const accountBalance = yield call(
      accountBalanceServices.accountBalance,
      securityAccount,
      currency,
    );

    yield put(
      accountBalanceSlice.actions.accountBalanceSuccess(accountBalance),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(accountBalanceSlice.actions.accountBalanceFailure());
  }
};

export const accountBalanceSagas = function* () {
  yield takeLatest(
    accountBalanceSlice.actions.accountBalanceRequest.type,
    accountBalanceWorker,
  );
};
